import type { Currency, Money } from "../../entities/ledger/types";
import { money } from "../../shared/lib/format";

// Shows a value in its own currency and, when available, the reporting
// equivalent. Base values are not repeated when they equal the native ones.
export function Layered({ native, base, reporting, baseCurrency, signed = false }: {
  native: Money; base?: Money | null; reporting?: Money | null; baseCurrency: Currency; signed?: boolean;
}) {
  const showBase = base && base.currency !== native.currency;
  return (
    <span className="layered">
      <strong>{money(native.minor, native.currency, signed)}</strong>
      {showBase ? <small>{money(base.minor, base.currency, signed)}</small> : null}
      {reporting && reporting.currency !== native.currency && reporting.currency !== baseCurrency ? <small>{money(reporting.minor, reporting.currency, signed)}</small> : null}
      {reporting && reporting.currency !== native.currency && reporting.currency === baseCurrency && !showBase ? <small>{money(reporting.minor, reporting.currency, signed)}</small> : null}
    </span>
  );
}

export function Pair({ label, base, reporting, signed = false }: { label: string; base: Money; reporting?: Money | null; signed?: boolean }) {
  return (
    <div className="pair">
      <span>{label}</span>
      <strong>{money(base.minor, base.currency, signed)}</strong>
      <small>{reporting && reporting.currency !== base.currency ? money(reporting.minor, reporting.currency, signed) : "\u00a0"}</small>
    </div>
  );
}
